// En qué pantalla está el usuario, sacado de la ruta (3.1, D2).
//
// **Se manda la clave, no el nombre.** `agents`, no «Agentes». El Brain ya
// sabe traducirla: su harness de producto lista cada sección con su clave
// interna y con cómo se llama en cada idioma. Mandarle el nombre obligaría a
// mantener aquí una segunda tabla de secciones, y el día que una cambie de
// nombre habría dos sitios que tocar y uno que se olvida.
//
// Y **no se manda lo que hay en la pantalla**: eso lo consulta él con sus
// herramientas. Lo que viaja en cada turno es lo mínimo para saber de qué le
// hablan —51 tokens medidos, frente a los 12.816 que ya cuestan sus
// herramientas—.

/** La sección de una ruta con idioma delante: `/es/knowledge` → `knowledge`. */
export function sectionFromRoute(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean)
  // El primero es el idioma. Si no hay nada detrás, es la raíz del idioma.
  return segments[1] ?? ''
}
